import React from "react";
import ServiceOne from "../../assets/doctor-loan-img.png";
import { useNavigate } from "react-router-dom";
import { FaImage, FaIdCard, FaFileAlt, FaHome, FaUsers, FaMoneyBillWave, FaUserMd  } from "react-icons/fa";
import { MdOutlineDescription } from "react-icons/md";


const DoctorLoanOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "doctor",
      title: "Doctor Loan",
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  return (
    <div className="loan-offer-wrapper">
      <div className="ourservice-logo">
         <div className="ourservice-text">
          <h2 className="ourservice-offer-subtitle">Doctor Loan</h2>
        </div>
        <p className="offer-title-ourservice offer-submain-title">
          {" "}
          Get Professional Loan -For Doctors From{" "}
          <span className="highlight-color">₹5 Lakh to ₹1 Crore*</span>
        </p>
      </div>

      <div className="loan-highlights">
        <div className="salary-rate-pair">
          <div className="salary-rate-list">
            <div className="salary-rate-box">
              <p>Right Lender Approval in</p>
              <h3>15min*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Interest Rate Starts @</p>
              <h3>10.25%*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Tenure up to</p>
              <h3>84*</h3>
              <p>Months</p>
            </div>
            <div className="salary-rate-box">
              <p>EMI </p>
              <h3>₹1673*</h3>
              <p>P/M</p>
            </div>
          </div>
        </div>
        <p className="offer-subtitle highlight-rate">
          Collateral Free up-to 1 Cr* Quick Funding up-to 30 Lakhs*
        </p>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Who Can Apply</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>CIBIL 700 & Above
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Age 25 to 65
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>All Salaried Professional Doctors (MBBS,MD,MS )
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Net Salary Min ₹30,000
            </p>
          </div>
            <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Own a Clinic/Hospital – Annual Turnover ₹6 Lakh & Above

            </p>
          </div>
        </div>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Documents</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Selfie (or ) Photo
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Pan
            </p>
          </div>
                   <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Aadhaar or E-Aadhaar
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Last 3 Month Pay Slip / Own a Clinic ITR for Last 2 yrs
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Last 6 Month Account Statement
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>MBBS Degree Certificate & Others if Required By the Lender
            </p>
          </div>
        </div>
      </div>
      <div className="offer-subtitle">
        <p>
          <span className="highlight-rate">Service to Tamil Nadu and Bangalore</span><br />
          (Right Lender Serviceable PIN code)
        </p>
      </div>

      <div className="apply-now-button">
        {plans.map((plan, index) => (
          <button
            className="apply-loan-button"
            key={index}
            onClick={() => handleApplyClick(plan.loanType)}
          >
            Proceed
          </button>
        ))}
      </div>
    </div>
  );
};

export default DoctorLoanOffer;
